import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import Assessment from './assessment';

class AssessmentList extends Component {
  render() {
    const { assessments } = this.props;

    return (
      <div>
        {assessments.map((assessment, index) =>
          <Row key={index}>
            <Col lg={12}>
              <Assessment assessment={assessment} />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default AssessmentList;



// WEBPACK FOOTER //
// ./src/components/assessments/assessment-list.jsx